// extracted by mini-css-extract-plugin
module.exports = {"tag":"StaffList_tag_3YYJ1","content":"StaffList_content_59j7X","spinAround":"StaffList_spinAround_1pg3N"};